import { QApi } from '../baseQuery';
import {
  USER_LOGIN,
  VERIFY_LOGIN,
  USER_GET_DETAIL,
  BUSINESS_DETAIL_CREATE,
  BUSINESS_DETAIL_UPDATE,
  UPDATE_PROFILE,
  HELP_AND_SUPPORT,
  FEEDBACK,
  GET_REPORT_DATA,
  GENERATE_REPORT,
  LOGOUT,
  GET_NOTIFICATION_LIST,
  DELETE_NOTIFICATION,
  UNREAD_COUNT,
  CONTACT_DETAIL_SEND,
  SEND_OTP,
  GET_SUBSCRIPTION_PLAN_LIST,
  USER_SUBSCRIBE_PLAN,
  GET_PAYMENT_HISTORY_LIST,
  USER_QR_INFO,
  USER_QR_DATA,
  USER_QR_REGENERATE,
  USER_QR_GET_INFO,
} from '../../config/ApiList';
export const UserApi = QApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (body) => {
        return {
          url: USER_LOGIN,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['UserApi'],
    }),
    verifyLogin: builder.mutation({
      query: (body) => {
        return {
          url: VERIFY_LOGIN,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['UserApi'],
    }),
    getUserDetail: builder.query({
      query: () => {
        return {
          url: USER_GET_DETAIL,
          method: 'GET',
        };
      },
      invalidatesTags: ['UserApi'],
    }),
    businessDetailCreate: builder.mutation({
      query: (body) => {
        return {
          url: BUSINESS_DETAIL_CREATE,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['UserApi'],
    }),
    businessDetailUpdate: builder.mutation({
      query: (body) => {
        return {
          url: BUSINESS_DETAIL_UPDATE + '/' + body?.id,
          method: 'PATCH',
          body: body?.params,
        };
      },
      transformErrorResponse: (response, meta, arg) => response,
      invalidatesTags: ['UserApi'],
    }),
    updateProfile: builder.mutation({
      query: (body) => {
        return {
          url: UPDATE_PROFILE,
          method: 'PATCH',
          body: body,
        };
      },
      transformErrorResponse: (response, meta, arg) => response,
      invalidatesTags: ['UserApi'],
    }),
    helpAndSupport: builder.mutation({
      query: (body) => {
        return {
          url: HELP_AND_SUPPORT,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['UserApi'],
    }),
    feedBack: builder.mutation({
      query: (body) => {
        return {
          url: FEEDBACK,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['UserApi'],
    }),
    getReportData: builder.query({
      query: () => {
        return {
          url: GET_REPORT_DATA,
          method: 'GET',
        };
      },
      invalidatesTags: ['UserApi'],
    }),
    generateReport: builder.mutation({
      query: ({ body, fileType }) => {
        let url = GENERATE_REPORT;
        if (fileType) {
          url = `${url}/${fileType}`;
          return {
            url,
            method: 'POST',
            body,
            responseHandler: (response) => response.blob(),
          };
        } else {
          return {
            url: `${url}/json`,
            method: 'POST',
            body,
          };
        }
      },
      keepUnusedDataFor: 0,
      invalidatesTags: ['UserApi'],
    }),
    generateInvoice: builder.mutation({
      query: ({ transactionId }) => {
        let url = `payment/${transactionId}/invoice`;
        return {
          url,
          method: 'GET',
          responseHandler: (response) => response.blob(),
        };
      },
      keepUnusedDataFor: 0,
      invalidatesTags: ['UserApi'],
    }),
    logout: builder.mutation({
      query: (body) => {
        return {
          url: LOGOUT,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['UserApi'],
    }),
    getNotificationList: builder.query({
      query: (params) => {
        return {
          url: GET_NOTIFICATION_LIST,
          method: 'GET',
          params: params,
        };
      },
      invalidatesTags: ['UserApi'],
    }),
    deleteNotification: builder.mutation({
      query: (params) => {
        let url = DELETE_NOTIFICATION;
        if (params?.notification_id) {
          url = `${DELETE_NOTIFICATION}/${params.notification_id}`;
        }
        return {
          url: url,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['UserApi'],
    }),
    getUnreadCount: builder.query({
      query: () => {
        return {
          url: UNREAD_COUNT,
          method: 'GET',
        };
      },
      keepUnusedDataFor: 0,
      invalidatesTags: ['UserApi'],
    }),
    contactDetailSend: builder.mutation({
      query: (body) => {
        return {
          url: CONTACT_DETAIL_SEND,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['UserApi'],
    }),
    businessVerifyEmail: builder.mutation({
      query: ({ token }) => {
        return {
          url: 'business/verify-email',
          method: 'GET',
          params: { token },
        };
      },
      invalidatesTags: ['UserApi'],
    }),

    verifyOtp: builder.mutation({
      query: (body) => {
        return {
          url: VERIFY_LOGIN,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['UserApi'],
    }),
    sendOtp: builder.mutation({
      query: (body) => {
        return {
          url: SEND_OTP,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['UserApi'],
    }),
    getPaymentHistoryList: builder.query({
      query: () => {
        return {
          url: GET_PAYMENT_HISTORY_LIST,
          method: 'GET',
        };
      },
      invalidatesTags: ['UserApi'],
    }),
    getUserServiceOrderList: builder.query({
      query: (params) => {
        return {
          url: 'user/service-order',
          method: 'GET',
          params: params,
        };
      },
      invalidatesTags: ['UserApi'],
    }),
    getUserPurchaseStats: builder.query({
      query: () => {
        return {
          url: 'user/purchase-stats',
          method: 'GET',
        };
      },
      invalidatesTags: ['UserApi'],
    }),
    getUserFilteredPurchaseStats: builder.query({
      query: (params) => {
        return {
          url: 'user/purchase-stats-filtered',
          method: 'GET',
          params: params,
        };
      },
      invalidatesTags: ['UserApi'],
    }),
    getOrderDetail: builder.query({
      query: (orderId) => {
        return {
          url: `order/${orderId}`,
          method: 'GET',
        };
      },
      invalidatesTags: ['UserApi'],
    }),
    getOrderInvoice: builder.mutation({
      query: (orderId) => {
        return {
          url: `order/${orderId}/invoice`,
          method: 'GET',
          responseHandler: (response) => response.blob(),
        };
      },
      keepUnusedDataFor: 0,
      invalidatesTags: ['UserApi'],
    }),
    // Service Purchase API endpoints
    purchaseServices: builder.mutation({
      query: (body) => {
        return {
          url: 'service-purchase/purchase-services',
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['UserApi'],
    }),
    purchaseServicesOwner: builder.mutation({
      query: (body) => {
        return {
          url: 'service-purchase/owner/purchase-services',
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['UserApi'],
    }),
    getServiceQuantityLimits: builder.query({
      query: ({ queueUserId, serviceId }) => {
        return {
          url: `service-purchase/queue-user/${queueUserId}/quantity-limits`,
          method: 'GET',
          params: serviceId ? { service_id: serviceId } : {},
        };
      },
      invalidatesTags: ['UserApi'],
    }),
    getAllServiceQuantityLimits: builder.query({
      query: ({ queueUserId, queueId }) => {
        return {
          url: `service-purchase/queue-user/${queueUserId}/all-quantity-limits`,
          method: 'GET',
          params: { queue_id: queueId },
        };
      },
      invalidatesTags: ['UserApi'],
    }),
    getPreJoinQuantityLimits: builder.query({
      query: ({ queueId, partySize = 1 }) => {
        return {
          url: `service-purchase/queue/${queueId}/pre-join-quantity-limits`,
          method: 'GET',
          params: { party_size: partySize },
        };
      },
      invalidatesTags: ['UserApi'],
    }),
    getServiceAvailability: builder.query({
      query: (serviceId) => {
        return {
          url: `service-purchase/services/${serviceId}/availability`,
          method: 'GET',
        };
      },
      invalidatesTags: ['UserApi'],
    }),
    validateServiceOrderModification: builder.mutation({
      query: ({ serviceOrderId, body }) => {
        return {
          url: `service-purchase/service-order/${serviceOrderId}/validate-modification`,
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['UserApi'],
    }),

    operatorInitiatePayment: builder.mutation({
      query: (body) => {
        return {
          url: 'service-purchase/owner/purchase-services',
          method: 'POST',
          body: body,
        };
      },
      invalidatesTags: ['UserApi'],
    }),

    operatorCompleteOfflinePayment: builder.mutation({
      query: ({ paymentTransactionId, notes }) => {
        return {
          url: `payment/${paymentTransactionId}/mark-offline-success`,
          method: 'POST',
          body: { notes },
        };
      },
      invalidatesTags: ['UserApi'],
    }),

    // QR Code endpoints
    getQRInfo: builder.query({
      query: () => {
        return {
          url: USER_QR_INFO,
          method: 'GET',
        };
      },
      providesTags: ['QRInfo'],
    }),

    getQRData: builder.query({
      query: () => {
        return {
          url: USER_QR_DATA,
          method: 'GET',
        };
      },
      providesTags: ['QRData'],
    }),

    regenerateQR: builder.mutation({
      query: () => {
        return {
          url: USER_QR_REGENERATE,
          method: 'POST',
        };
      },
      invalidatesTags: ['QRInfo', 'QRData'],
    }),

    getUserInfoFromQR: builder.mutation({
      query: (body) => {
        return {
          url: USER_QR_GET_INFO,
          method: 'POST',
          body: body,
        };
      },
    }),

    // Auto-enrollment schedule endpoint
    getAutoEnrollmentSchedule: builder.query({
      query: (queueUserId) => {
        return {
          url: `queue-user/${queueUserId}/enrollment-schedule`,
          method: 'GET',
        };
      },
      providesTags: ['AutoEnrollmentSchedule'],
    }),

    // Skip enrollment endpoint
    skipEnrollment: builder.mutation({
      query: ({ queueUserId, bookingDate }) => {
        return {
          url: `queue-user/${queueUserId}/skip-enrollment`,
          method: 'POST',
          body: {
            booking_date: bookingDate,
          },
        };
      },
      invalidatesTags: ['AutoEnrollmentSchedule'],
    }),

    // Undo skip enrollment endpoint
    undoSkipEnrollment: builder.mutation({
      query: ({ queueUserId, bookingDate }) => {
        return {
          url: `queue-user/${queueUserId}/undo-skip-enrollment`,
          method: 'POST',
          body: {
            booking_date: bookingDate,
          },
        };
      },
      invalidatesTags: ['AutoEnrollmentSchedule'],
    }),

    // Get available batches for rescheduling (user-facing)
    getAvailableBatchesForReschedule: builder.query({
      query: ({ queueUserId, bookingDate }) => {
        return {
          url: `queue-user/${queueUserId}/available-batches`,
          method: 'GET',
          params: {
            booking_date: bookingDate,
          },
        };
      },
      providesTags: ['AvailableBatches'],
    }),

    // Shift batch for rescheduling
    shiftBatch: builder.mutation({
      query: ({ queueUserId, shifts }) => {
        return {
          url: `queue-user/${queueUserId}/bulk-shift-batch`,
          method: 'POST',
          body: {
            shifts: shifts,
          },
        };
      },
      invalidatesTags: ['AutoEnrollmentSchedule', 'AvailableBatches'],
    }),

    // Find batches
    findBatches: builder.mutation({
      query: ({ queueUserId, batchName, startTime, bookingDate }) => {
        return {
          url: `queue-user/${queueUserId}/find-batches`,
          method: 'POST',
          body: {
            batch_name: batchName,
            start_time: startTime,
            booking_date: bookingDate,
          },
        };
      },
      invalidatesTags: ['FindBatches'],
    }),
  }),
});

export const {
  useLoginMutation,
  useVerifyLoginMutation,
  useVerifyOtpMutation,
  useGetUserDetailQuery,
  useBusinessDetailCreateMutation,
  useBusinessDetailUpdateMutation,
  useHelpAndSupportMutation,
  useFeedBackMutation,
  useGetReportDataQuery,
  useGenerateReportMutation,
  useGenerateInvoiceMutation,
  useLogoutMutation,
  useGetNotificationListQuery,
  useGetUnreadCountQuery,

  useSendOtpMutation,
  useUpdateProfileMutation,
  useGetSubscriptionPlanListQuery,
  useUserSubscribePlanMutation,
  useGetPaymentHistoryListQuery,
  useDeleteNotificationMutation,
  useContactDetailSendMutation,
  useBusinessVerifyEmailMutation,
  useGetUserServiceOrderListQuery,
  useGetUserPurchaseStatsQuery,
  useGetUserFilteredPurchaseStatsQuery,
  useGetOrderDetailQuery,
  useGetOrderInvoiceMutation,
  // Service Purchase hooks
  usePurchaseServicesMutation,
  usePurchaseServicesOwnerMutation,
  useGetServiceQuantityLimitsQuery,
  useGetAllServiceQuantityLimitsQuery,
  useGetPreJoinQuantityLimitsQuery,
  useGetServiceAvailabilityQuery,
  useValidateServiceOrderModificationMutation,
  // Operator Payment hooks
  useOperatorInitiatePaymentMutation,
  useOperatorCompleteOfflinePaymentMutation,
  useGetQRInfoQuery,
  useGetQRDataQuery,
  useRegenerateQRMutation,
  useGetUserInfoFromQRMutation,
  useGetAutoEnrollmentScheduleQuery,
  useSkipEnrollmentMutation,
  useUndoSkipEnrollmentMutation,
  useGetAvailableBatchesForRescheduleQuery,
  useShiftBatchMutation,
  useFindBatchesMutation,
} = UserApi;
